/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OAuthTypeEnum = {
    type: 'Enum',
} as const;
